import { createFileRoute } from '@tanstack/react-router';

import { assertUuidRouteParams } from '../../lib/assert-uuid-route-params.js';
import { ManufacturingOrderDetailPage } from '../../modules/manufacturing/manufacturing-order-detail-page.js';

export const Route = createFileRoute('/manufacturing/$manufacturingOrderId')({
  beforeLoad: ({ params }) => assertUuidRouteParams(params),
  component: ManufacturingOrderDetailRoute,
});

// eslint-disable-next-line react-refresh/only-export-components
function ManufacturingOrderDetailRoute() {
  const { manufacturingOrderId } = Route.useParams();
  return <ManufacturingOrderDetailPage manufacturingOrderId={manufacturingOrderId} />;
}
